import {
  IInsiderTileBadgeRendererProps,
  InsiderTileBadgeRenderer,
} from "@faire/retailer-visitor-shared/components/InsiderBadge/InsiderTileBadgeRenderer";
import { MaybeBrandReviewTile } from "@faire/retailer-visitor-shared/components/MaybeBrandReviewTile/MaybeBrandReviewTile";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BrandInfoProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/brandInfoProps";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BrandCatalogSizeText } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandCatalogSizeText";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BrandInfoWrapper } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandInfoWrapper";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BrandMinimum } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandMinimum";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BrandNameText } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandNameText";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { BrandPromoText } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/BrandPromoText";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { ProductInfoWrapper } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/components/ProductInfoWrapper";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SearchProductTileBrandLink } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/Links/SearchProductTileBrandLink";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { SearchProductTileBrandLinkProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/Links/SearchProductTileBrandLinkProps";
import { ILeanProductTile } from "@faire/retailer-visitor-shared/features/MarketplaceItems/MarketplaceProduct/LeanProtos/ILeanProductTile";
import { InsiderLinkClientWrapper } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/__internal__/InsiderLinkClientWrapper";
import { MarketplaceProductBrandLinkBase } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/__internal__/SearchMarketplaceProductBrandLinkBase";
import { IApplicableMembershipBenefits } from "@faire/web-api--source/indigofair/data/IApplicableMembershipBenefits";
import { IFaireIcon } from "@faire/web-api--source/indigofair/data/IFaireIcon";
import { IFaireMoney } from "@faire/web-api--source/indigofair/data/IFaireMoney";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { localNum } from "@faire/web/common/localization/localNum";
import { Row } from "@faire/web/slate/Layout/Row";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { CountryFlag, hasCountryFlag } from "@faire/web/ui/CountryFlag";
import { Link } from "@faire/web/ui/LinkAnchor";
import * as React from "react";

import { ProductLinkProps } from "../ProductTile";

interface IDiscoveryProductTileBrandInfoProps {
  token: string | undefined;
  name: string | undefined;
  icon: IFaireIcon | undefined;
  minimumOrderAmount: IFaireMoney | undefined;
  insiderBenefits: IApplicableMembershipBenefits | undefined;
  insiderLabelText: string | undefined;
  shipsFromMessage: string | undefined;
  flagCountryCode: keyof typeof ISO3166Alpha3 | undefined;
  catalogSizeText: string | undefined;
}

export const discoveryProductTileBrandInfoParamsILeanProductTileAdapter = (
  productTileBrand: ILeanProductTile.IBrand
): IDiscoveryProductTileBrandInfoProps => {
  return {
    token: productTileBrand.token,
    name: productTileBrand.name,
    icon: productTileBrand.icon,
    minimumOrderAmount: productTileBrand.minimum_order_amount,
    insiderBenefits: productTileBrand.insider_benefits,
    insiderLabelText: productTileBrand.insider_label?.text,
    shipsFromMessage: productTileBrand.ships_from_message,
    flagCountryCode: productTileBrand.flag_country_code,
    catalogSizeText: productTileBrand.catalog_size,
  };
};

export const discoveryProductTileBrandInfoParamsBrandInfoPropsAdapter = (
  props: BrandInfoProps
): IDiscoveryProductTileBrandInfoProps => {
  return {
    token: props?.brandToken,
    name: props?.brandName,
    icon: props?.brandIcon,
    minimumOrderAmount: props?.minimumOrderAmount,
    insiderBenefits: props?.insiderBadgeProps?.insiderBenefits,
    insiderLabelText: props?.insiderBadgeProps?.insiderLabelText,
    shipsFromMessage: props?.shipsFromMessage,
    flagCountryCode: props?.flagCountryCode,
    catalogSizeText: props?.catalogSizeText,
  };
};
export interface DiscoveryProductTileBrandInfoProps {
  brand: IDiscoveryProductTileBrandInfoProps;
  // This prop is ued in both composable and rsc tile, not used in legacy product tile
  shouldUseClickContext?: boolean;
  isLoggedInRetailer?: boolean;
  onBrandLinkClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  generateBrandUrl?: (brandToken: string) => string | undefined;
  dataTestId?: string | undefined;
  selectedProductOptionToken?: string;
  productLinkProps?: ProductLinkProps;
  isLoaded: boolean;
  avgBrandReviewRating: string | undefined;
  brandReviewCount: number | undefined;
  brandPromoText: string | undefined;
  insiderBadgeProps: IInsiderTileBadgeRendererProps;
  isHighlightedProductForPromotionalEvent: boolean | undefined;
  onLinkClickHandler?: (ev: React.MouseEvent<HTMLAnchorElement>) => void;
  brandLinkProps?: SearchProductTileBrandLinkProps;
  prefetchPDPOnMouseDown?: () => void;
  onTouchStartPrefetch?: () => void;
  shouldHidePriceProminencePriceTestV3?: boolean;
}

export const DiscoveryProductTileBrandInfo: React.FC<
  DiscoveryProductTileBrandInfoProps
> = ({
  brand,
  shouldUseClickContext,
  isLoggedInRetailer,
  onBrandLinkClick,
  generateBrandUrl,
  dataTestId,
  selectedProductOptionToken,
  productLinkProps,
  isLoaded,
  avgBrandReviewRating,
  brandReviewCount,
  brandPromoText,
  insiderBadgeProps,
  isHighlightedProductForPromotionalEvent,
  onLinkClickHandler,
  brandLinkProps,
  prefetchPDPOnMouseDown,
  onTouchStartPrefetch,
  shouldHidePriceProminencePriceTestV3,
}) => {
  const hasFlag = brand.flagCountryCode
    ? hasCountryFlag(brand.flagCountryCode)
    : false;

  const pdpLinkContents = (
    <ProductInfoWrapper>
      <BrandMinimum
        minimumOrderAmount={brand.minimumOrderAmount}
        avgBrandReviewRating={avgBrandReviewRating}
        isLoggedInRetailer={isLoggedInRetailer}
      />
      {insiderBadgeProps.insiderLabelText ? (
        <InsiderTileBadgeRenderer {...insiderBadgeProps} />
      ) : null}
      <BrandPromoText
        promoText={brandPromoText}
        isHighlightedPromo={isHighlightedProductForPromotionalEvent}
      />
    </ProductInfoWrapper>
  );

  const brandLinkContents = (
    <>
      <BrandNameText
        brandToken={brand.token ?? ""}
        brandName={brand.name ?? ""}
        isLoaded={isLoaded}
        brandIcon={brand.icon}
        addUnderline={!shouldHidePriceProminencePriceTestV3}
      />
      <BrandCatalogSizeText
        brandToken={brand.token ?? ""}
        text={brand.catalogSizeText ?? ""}
        isLoaded={isLoaded}
      />
    </>
  );

  return (
    <BrandInfoWrapper
      shouldHidePriceProminencePriceTestV3={
        shouldHidePriceProminencePriceTestV3 ?? false
      }
    >
      {brandLinkProps ? (
        <SearchProductTileBrandLink data={brandLinkProps}>
          {brandLinkContents}
        </SearchProductTileBrandLink>
      ) : (
        <MarketplaceProductBrandLinkBase
          brandToken={brand.token ?? ""}
          onBrandLinkClick={onBrandLinkClick}
          generateBrandUrl={generateBrandUrl}
        >
          {brandLinkContents}
        </MarketplaceProductBrandLinkBase>
      )}
      {shouldUseClickContext ? (
        <InsiderLinkClientWrapper
          brandToken={brand.token}
          selectedProductOptionToken={selectedProductOptionToken}
          dataTestId={dataTestId}
        >
          {pdpLinkContents}
        </InsiderLinkClientWrapper>
      ) : (
        <Link
          onClick={onLinkClickHandler}
          data-test-id={dataTestId}
          to={productLinkProps?.productUrl ?? ""}
          replace={productLinkProps?.replace}
          onMouseDown={prefetchPDPOnMouseDown}
          onTouchStart={onTouchStartPrefetch}
        >
          {pdpLinkContents}
        </Link>
      )}
      {!isLoggedInRetailer ? (
        <>
          <MaybeBrandReviewTile
            rating={ratingString(avgBrandReviewRating, brandReviewCount)}
          />
          {hasFlag ? (
            <Row align="center">
              <CountryFlag country={brand.flagCountryCode} size="16px" />
              <Spacer width={6} />
              <Typography variant="paragraphSansRegular">
                {brand.shipsFromMessage}
              </Typography>
            </Row>
          ) : null}
        </>
      ) : null}
    </BrandInfoWrapper>
  );
};

const ratingString = (
  avgBrandReviewRating: string | undefined,
  brandReviewCount: number | undefined
) => {
  if (avgBrandReviewRating && brandReviewCount) {
    return `${avgBrandReviewRating} (${localNum(brandReviewCount)})`;
  }
  return undefined;
};
